import React, { Component } from "react";
import { connect } from "react-redux";

import SearchComponent from "./SearchComponent";
import {
  showPellet,
  showDirectory,
  showDashboard,
  setPelletSelectedOrg,
  setDirectorySelectedOrg,
  setDashboardSelectedOrg
} from "Actions";

class SearchContainer extends Component {
  handleSelectArea(area, e) {
    const {
      showPellet,
      showDirectory,
      showDashboard,
      pellet,
      directory,
      dashboard
    } = this.props;
    //const check = e.currentTarget;

    switch (area) {
      case "BILLTOBOX":
        showPellet(!pellet);
        break;
      case "DIRECTORY":
        showDirectory(!directory);
        break;
      case "DASHBOARD":
        showDashboard(!dashboard);
        break;
      default:
    }
  }

  handleClientSelected = client => {
    const {
      setPelletSelectedOrg,
      setDirectorySelectedOrg,
      setDashboardSelectedOrg
    } = this.props;

    setPelletSelectedOrg(client);
    setDirectorySelectedOrg(client);
    setDashboardSelectedOrg(client);
  };

  render() {
    const { pellet, directory, dashboard } = this.props;

    return (
      <SearchComponent
        handleSelectArea={this.handleSelectArea.bind(this)}
        pellet={pellet}
        directory={directory}
        dashboard={dashboard}
        onClientSelected={this.handleClientSelected}
      />
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  pellet: state.params.visibleAreas.pellet,
  directory: state.params.visibleAreas.directory,
  dashboard: state.params.visibleAreas.dashboard
});

const mapDispatchToProps = dispatch => ({
  showPellet: isVisible => dispatch(showPellet(isVisible)),
  showDirectory: isVisible => dispatch(showDirectory(isVisible)),
  showDashboard: isVisible => dispatch(showDashboard(isVisible)),
  setPelletSelectedOrg: org => dispatch(setPelletSelectedOrg(org)),
  setDirectorySelectedOrg: org => dispatch(setDirectorySelectedOrg(org)),
  setDashboardSelectedOrg: org => dispatch(setDashboardSelectedOrg(org))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchContainer);



// WEBPACK FOOTER //
// ./src/components/Community/WorkPlace/Search/SearchContainer.js